import { render } from "./WebsiteIcon.vue?vue&type=template&id=1353f728&scoped=true"
import script from "./WebsiteIcon.vue?vue&type=script&lang=js"
export * from "./WebsiteIcon.vue?vue&type=script&lang=js"

import "./WebsiteIcon.vue?vue&type=style&index=0&id=1353f728&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1353f728"]])

export default __exports__